import {useEffect} from '@wordpress/element';
import {swiffyslider} from 'swiffy-slider'
window.swiffyslider = swiffyslider;


/**
 * [shetradesBlockView description]
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
export function shetradesBlockView(props) {
	
	const {attributes} = props;

	useEffect(() => { 	
		if (!attributes.blockShow) return false;
   		window.swiffyslider.init();
   		
  	}, [attributes.blockShow])

	if (!attributes.blockShow) return false;

	var isEmpty = true;
 
	//type:document
	if (attributes.dataType == 'document') {
		
		let carouselItemsImages = [];

		for (let i = 1; i <= attributes.dataItems; i++) { 
			var image = 'image' + i;
			var file = 'file' + i;
			var fileTitle = 'fileTitle' + i;

			if ((attributes[image]) && (attributes[file]) && (attributes[fileTitle])) { 

				let carouselItem = 
					<div className="doc">
            			<div className="image">  
            				<img src={attributes[image].url} />      				
						</div>
						<a href={attributes[file].url}>
            			<div className="info">				
							<div className="file-info-bar">
								<div className="short-title"><p>{attributes[fileTitle]}</p></div>
							</div>
							<div className="link"></div>
						</div>
						</a>
	  				</div>

				carouselItemsImages.push(carouselItem)	;
				isEmpty = false;
			}
		}

		let carouselClasses = 'swiffy-slider';
		carouselClasses += ' slider-item-show' + attributes.itemsShow; 
		carouselClasses += (attributes.autoplay) ? ' slider-nav-autoplay' : '';

		var carousel = <div className="swiffy-slider-wrapper">
			<div className={carouselClasses}>
			    <ul className="slider-container">
			        {carouselItemsImages}
			    </ul>

			    <button type="button" className="slider-nav"></button>
			    <button type="button" className="slider-nav slider-nav-next"></button>

			    <div className="slider-indicators">
			        <button className="active"></button>
			        <button></button>
			        <button></button>
			    </div>
			</div>
		</div>


	//type:image
	} else if (attributes.dataType == 'image') {

		let carouselItemsImages = [];
		let imageClasses = 'height-' + attributes.typeImageItemHeight;

		for (let i = 1; i <= attributes.dataItems; i++) {	
			var image = 'image' + i;

			if (attributes[image]) {
				carouselItemsImages.push(<li className=""><img className={imageClasses} src={attributes[image].url} /></li>);
				isEmpty = false;
			}
		}

		let carouselClasses = 'swiffy-slider slider-nav-mousedrag';
		carouselClasses += ' slider-item-show' + attributes.itemsShow; 
		carouselClasses += (attributes.autoplay) ? ' slider-nav-autoplay' : '';

		var carousel = <div className="swiffy-slider-wrapper">
			<div className={carouselClasses}>
			    <ul className="slider-container">
			        {carouselItemsImages}
			    </ul>

			    <button type="button" className="slider-nav"></button>
			    <button type="button" className="slider-nav slider-nav-next"></button>

			    <div className="slider-indicators">
			        <button className="active"></button>
			        <button></button>
			        <button></button>
			    </div>
			</div>
		</div>
	}

	return <React.Fragment> 
				{(isEmpty) ? (<React.Fragment>[Carousel Block]</React.Fragment>) : carousel} 
			</React.Fragment>
}